import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "src/langs/en";
import es from "src/langs/es";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: en,
      es: es,
    },
    fallbackLng: "en",
    debug: false,
    ns: ["common", "glossary"],
    defaultNS: "common",
    interpolation: {
      escapeValue: false,
      formatSeparator: ",",
    },
  });

export default i18n;
